import { avatar1, avatar2 } from './images'

export const messages = [
  {
    id: 1,
    text: 'Здравствуйте, Анна! Подскажите, пожалуйста, где посмотреть тайминг обучения, до какого числа необходимо пройти темы',
    avatarSrc: avatar1.default.src
  },
  {
    id: 2,
    text: 'Весь этот модуль предполагается на 2 месяца, то есть дедлайны по сдаче заданий - 20 мая. Так будет комфортнее идти дальше, изучив всю информацию и выполнив задания',
    avatarSrc: avatar2.default.src
  },
  {
    id: 3,
    text: 'Спасибо большое!',
    avatarSrc: avatar1.default.src
  }
]

export const testimonials = [
  'В киноклубах вы сможете анализировать фильмы с точки зрения психологии и обсуждать их с коллегами',
  'Во время практики преподаватели и <span style="color: #7D5EE4;">супервизоры</span> будут отслеживать динамику и прогресс в обучении',
  'Куратор будет сопровождать вас на протяжении всего обучения, помогая решить возникающие вопросы'
]
